import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap5';

import TextFilter from './Filter/Text';
import SelectFilter from './Filter/Select';

export default function Filter({ filterColumn }) {
  const { name, filter: { type, options } } = filterColumn;

  const inputElement = () => {
    switch (type) {
      case 'TEXT':
        return <TextFilter name={name} />;
      case 'SINGLE_SELECT':
        return (
          <SelectFilter
            name={name}
            isMulti={false}
            options={options}
          />
        );
      case 'MULTI_SELECT':
        return (
          <SelectFilter
            name={name}
            isMulti
            options={options}
          />
        );
      default:
        throw Error(`Unknown filter: ${type}`);
    }
  };

  return (
    <Col className="mb-3">
      {inputElement()}
    </Col>
  );
}

Filter.propTypes = {
  filterColumn: PropTypes.object.isRequired,
};
